<template>
  <div class="comment-container">
    <comment-card
      :comment="comment"
      @reply="handleReply"
      v-if="UserCanComment"
      :questionOpen="questionOpen"
      @delete="handleDelete"
    />
    <ol v-if="comment.children && comment.children.length" class="replies-list">
      <li v-for="(child,index) in comment.children" :key="child.id" :id="`comment_${child.id}`">
        <icon name="replies" class="reply-icon" />
        <node
          :comment="child"
          @reply="handleReply"
          @submit="handleSubmit"
          :replyTo="child.id"
          v-if="index < 2 || !showAllComments"
          :questionOpen="questionOpen"
          @delete="handleDelete"
        ></node>
      </li>
    </ol>

    <p class="view-more" v-if="showAllComments && comment.children">
      <icon name="replies" />
      {{' '}}
      <base-button :asLink="true" @click="showReplies = !showReplies">View more replies</base-button>
    </p>
    <add-reply @submit="handleSubmit" v-if="replyTo == comment.id && questionOpen" />
  </div>
</template>

<script>
/**
 * This needs to be the top level of a nested component list
 */
import { CommentCard, AddReply } from "./index";
import { mapState } from "vuex";
export default {
  name: "node",
  props: {
    comment: {
      type: Object,
      default: () => {}
    },
    UserCanComment: {
      type: Boolean,
      default: true
    },
    questionOpen: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleSubmit(val) {
      this.$emit("submit", val);
    },
    handleReply(val) {
      this.$emit("reply", val);
    },
    handleDelete(comment) {
      this.$emit("delete", comment);
    }
  },
  components: {
    CommentCard,
    AddReply
  },
  computed: {
    ...mapState("Comments", ["replyTo"]),
    showAllComments() {
      return (
        !this.showReplies &&
        (this.comment.children && this.comment.children.length > 3)
      );
    }
  },
  data() {
    return {
      showReplies: false
    };
  }
};
</script>

<style scoped lang="scss">
.comment-container {
  margin-top: 1em;
  margin-bottom: 1em;

  + .comment-container {
    padding-top: 1em;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  /**
   * Nested
   **/
  .comment-container {
    border: none;
    margin-bottom: 0;
  }
}

li {
  margin-left: 3em;
  border-bottom: 0;
  padding-bottom: 0;
  padding-left: 25px;
  list-style-type: none;
  position: relative;
  //   border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  li li {
    border-bottom: 0;
    margin-left: -25px;
  }
}

.view-more {
  margin-left: 10%;
}

.reply-icon {
  position: absolute;
  top: 15px;
  left: 0;
}
</style>